import React from 'react';

import EmailRecoverForm from '@app/components/UI/Login/EmailRecoverForm/EmailRecoverForm';
import PhoneRecoverForm from '@app/components/UI/Login/PhoneRecoverForm/PhoneRecoverForm';
import styles from '@app/components/UI/Login/RecoverForm/RecoverForm.module.scss';
import VerifyCodeAndSetPasswordForm from '@app/components/UI/Login/VerifyCodeAndSetPasswordForm/VerifyCodeAndSetPasswordForm';

export enum TypeRecover {
	email = 1,
	phone = 2,
	verifyCode = 3,
}

const EmailSvg: React.FC = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			{/* eslint-disable-next-line max-len */}
			<path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
		</svg>
	);
};

const ArrowRightSVG: React.FC = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
			{/* eslint-disable-next-line max-len */}
			<path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
		</svg>
	);
};

const SMS_SVG: React.FC = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			{/* eslint-disable-next-line max-len */}
			<path d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8H152c8.8 0 16 7.2 16 16s-7.2 16-16 16H132.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM372.8 176H392c8.8 0 16 7.2 16 16s-7.2 16-16 16H372.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7c0-20.3 16.5-36.8 36.8-36.8zm-152 6.4L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6z" />
		</svg>
	);
};

const RecoverForm: React.FC = () => {
	const [typeRecover, setTypeRecover] = React.useState<null | TypeRecover>(null);
	const [phoneNumber, setPhoneNumber] = React.useState<string>('');
	const [email, setEmail] = React.useState<string>('');

	React.useEffect(() => {
		if (typeRecover === TypeRecover.email && phoneNumber) {
			setPhoneNumber('');
		}
		if (typeRecover === TypeRecover.phone && email) {
			setEmail('');
		}
	}, [typeRecover]);

	return typeRecover === TypeRecover.email ? (
		<EmailRecoverForm onChangeTypeRecover={setTypeRecover} onChangeEmail={setEmail} />
	) : typeRecover === TypeRecover.phone ? (
		<PhoneRecoverForm onChangeTypeRecover={setTypeRecover} onChangePhoneNumber={setPhoneNumber} />
	) : typeRecover === TypeRecover.verifyCode ? (
		<VerifyCodeAndSetPasswordForm
			onChangeTypeRecover={setTypeRecover}
			data={phoneNumber ? { phoneNumber } : { email }}
		/>
	) : (
		<>
			<h1 className="h2">
				Forgot your password?
			</h1>
			<h2 className="h3 text-center">
				That's OK. We can help.
			</h2>
			<p className="h4 text-center">
				Where would you like us to send a reset code?
			</p>
			<p className="h4 text-center">
				<small>Please wait 5 minutes before requesting an additional code.</small>
			</p>
			<div className={styles.recoveryMethodWrap}>
				<div
					className={styles.metod}
					onClick={() => setTypeRecover(TypeRecover.email)}
				>
					<div className={styles.metod__img}>
						<EmailSvg />
					</div>
					<div className={styles.metod__label}>
						Email
						<div className={styles.arrowRight}>
							<ArrowRightSVG />
						</div>
					</div>
				</div>
				<div
					className={styles.metod}
					onClick={() => setTypeRecover(TypeRecover.phone)}
				>
					<div className={styles.metod__img}>
						<SMS_SVG />
					</div>
					<div className={styles.metod__label}>
						Text
						<div className={styles.arrowRight}>
							<ArrowRightSVG />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default RecoverForm;
